import { Link } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

export default function ExpertDashboard() {
  const { user } = useAuth()

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Welcome back!</h1>
        <p className="text-gray-600">Here's what's happening with your profile</p>
      </div>

      {/* Quick stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Profile Views</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">Last 30 days</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Applications</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">Pending review</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Active Contracts</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">In progress</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Verified Skills</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">
            <Link to="/expert/assessments" className="text-primary-600 hover:text-primary-500">
              Take assessment →
            </Link>
          </div>
        </div>
      </div>

      {/* Profile completion prompt */}
      <div className="card mb-8 bg-gradient-to-r from-primary-50 to-accent-50">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Complete your profile</h2>
            <p className="mt-1 text-gray-600">
              A complete profile helps companies find you and increases your chances of getting hired.
            </p>
            <div className="mt-4">
              <Link to="/dashboard/profile" className="btn-primary">
                Edit Profile
              </Link>
            </div>
          </div>
          <div className="text-right">
            <div className="text-3xl font-bold text-primary-600">0%</div>
            <div className="text-sm text-gray-500">Complete</div>
          </div>
        </div>
      </div>

      {/* Quick actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-4">Quick Actions</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/expert/assessments" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Take a skill assessment
              </Link>
            </li>
            <li>
              <Link to="/experts" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Browse job listings
              </Link>
            </li>
            <li>
              <Link to="/dashboard/profile" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Update your profile
              </Link>
            </li>
          </ul>
        </div>

        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-4">Recent Activity</h3>
          <div className="text-center py-8 text-gray-500">
            <p>No recent activity</p>
            <p className="text-sm mt-1">Your applications and contract updates will appear here</p>
          </div>
        </div>
      </div>
    </div>
  )
}
